export const RECENT_COLORS_STORAGE_KEY = "ac_recent_colors";
export const MAX_RECENT_COLORS = 18;

export const PREDEFINED_COLOR_COLUMNS: string[][] = [
  ["#4D5561", "#999EA7", "#D2D5DB", "#E5E7EC", "#EEF0F3"],
  ["#F53D68", "#F75F82", "#F9819D", "#FCC0CE", "#FDDDE5"],
  ["#F04437", "#F97066", "#FCA19B", "#FECDCA", "#FEE4E2"],
  ["#EF681F", "#F2854A", "#F59F70", "#F8BFA0", "#FCDFCF"],
  ["#F8A900", "#FFC64D", "#FFD375", "#FFD57A", "#FFEABD"],
  ["#65C51C", "#85E139", "#A6EF66", "#D0F8AB", "#E3FBCC"],
  ["#15B79E", "#30D9BF", "#73E7D5", "#99EBDE", "#BFF3EB"],
  ["#0BA4EB", "#36BFF9", "#7BD4FD", "#B9E6FE", "#E0F2FE"],
  ["#927BF0", "#AB96FF", "#CCBFFF", "#E2DBFF", "#F0EDFF"],
];

export const BROWSER_PALETTE_DELAY = 800;
